const PlotMoreInformationType={OVERVIEW:'overview', GALLERY:'gallery', FLOOR_PLANS:'floorPlans'};
export default PlotMoreInformationType;		